import { reduceZoomDomain } from '../../../../core/components/interactions-state-helpers/reducers/zoom-reducers.js';
import { useSynchronizedSelection } from '../../../../core/components/shared-chart-interactions/hooks/useSynchronizedSelection.js';
import { getZoomStep } from '../../../../core/components/zoom/utils/get-zoom-step.js';
import type { ZoomChangeType } from '../../../../core/types/zoom.js';
import { useSetState } from '../../../hooks/store/selectors.js';
import { useChartInteractions } from '../../../hooks/useChartInteractions.js';
import { useInfiniteZoomConfig } from '../../../hooks/useInfiniteZoomConfig.js';
import { useXScales } from '../../../hooks/useXScale.js';

/**
 * Returns a callback which given a delta in pixels, will apply the zoom interaction and update the state accordingly
 */
export const useApplyZoomDelta = () => {
  const { onZoomChange } = useChartInteractions();
  const { currentScale, initialScale } = useXScales();
  const infiniteZoom = useInfiniteZoomConfig();
  const setState = useSetState();
  const { resetSelectionState } = useSynchronizedSelection();

  const initialDomain = initialScale.domain();

  return (deltaStart: number, deltaEnd: number, type: ZoomChangeType) => {
    const { nextDomain, zoomInEnabled, zoomOutEnabled } = getZoomStep(
      currentScale,
      [+initialDomain[0], +initialDomain[1]],
      infiniteZoom,
      deltaStart,
      deltaEnd,
    );

    onZoomChange?.(new Date(nextDomain[0]), new Date(nextDomain[1]), type);
    resetSelectionState?.();

    setState(reduceZoomDomain(nextDomain, zoomInEnabled, zoomOutEnabled));
  };
};
